<template>
  <div class="outer-container" style="background-color:white">
    <div class="container">
      <div class="inner-container">
        <div>
          <img
            :src="info.mainImg"
            alt=""
            style="border-radius:50%; max-width:330px"
          />
        </div>
        <div class="flex-right">
          <div class="upper">
            <img src="../../assets/shera/1.svg" alt="" />
            <div class="div" style="padding:20px 0"></div>

            <h3 class="" style="color: #29292B">
              {{ info.paragraph }}
            </h3>
            <div class="div" style="padding:20px 0"></div>
          </div>
          <div class="lower">
            <h2>
              {{ info.name }}
            </h2>
            <h5 style="white-space:pre">
              {{ info.designation }}
            </h5>
            <img
              src="../../assets/shera/2.svg"
              alt=""
              style="text-align:right"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      require: true,
    },
  },
}
</script>

<style scoped>
.credits {
  font: 400 0.75rem/1rem 'Manrope';
  color: #626367;
}
.inner-container {
  max-width: 1270px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding-bottom: 100px;
}
.flex-right {
  display: flex;
  flex-direction: column;
}
.upper,
.lower {
  padding: 0 50px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.flex-right h3 {
  font: 400 1rem/1.2rem 'Manrope';
  color: white;
}

.lower h2 {
  font: 700 1.5rem/1.75rem 'Manrope';
  color: #29292b;
}
.lower h5 {
  font: 400 0.875rem/1rem 'Manrope';
  color: #29292b;
}

.lower {
  margin-top: -50px;
  display: flex;
  flex-direction: column;
}
.lower img {
  align-self: flex-end;
}
.video {
  width: 849px;
  height: 478px;
}
@media only screen and (max-width: 600px) {
  .inner-container {
    max-width: 1270px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr;
    padding-bottom: 100px;
  }
  .video {
    width: 359px;
    height: 278px;
  }
  .upper img {
    padding-bottom: 25px;
  }
  .lower img {
    padding-top: 20px;
  }
}
</style>
